var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[_c('UiTab',{attrs:{"to":"/help"}},[_vm._v("Help")]),_c('UiTab',{attrs:{"to":"/help/guides"}},[_vm._v("Guides")]),_c('UiTab',{attrs:{"to":"/help/earlyaccess"}},[_vm._v("Terms of service")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }